module.exports = __webpack_public_path__ + "static/media/tag-icon.971d27e6.png";